import { useQuery } from "@apollo/client/react";
import GET_CLIENT_RISK_SCORE from "../../queries/aml/getClientRiskScore";
import type { ClientModel } from "../../../models/ClientModel";

type ClientQueryResponse = {
  client: ClientModel;
};

export const useClientRiskScore = (id: string, isHandled?: boolean) => {
  const { data, error, loading, refetch } = useQuery<ClientQueryResponse>(
    GET_CLIENT_RISK_SCORE,
    {
      variables: { identifier: id, isHandled: isHandled },
      fetchPolicy: "no-cache",
    }
  );
  return { clientRiskScore: data?.client, error, loading, refetch };
};
